import { materialGetAllForDropdown } from "@/api/material";

const state = {
    matrialOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.matrialOptions = data;
    },
};

const actions = {
    async materialGetAllForDropdown({ commit }) {
        let res = await materialGetAllForDropdown();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/material.js